<template>
    <b-container fluid>
        <header-buttons
        ></header-buttons>
        <b-row>
            <b-col cols="12" class="mt-3">
                <admin-society-table
                        @onImpersonate="impersonate"
                        @onResetPasswordItem="resetPassword"
                        @onUpdate="onUpdate"
                        :key="societiesTablekey">
                </admin-society-table>
            </b-col>
        </b-row>
        <inter-modal
                title-icon="flaticon-football-club"
                :buttonPrimary="buttonPrimary"
                title="Modifica Society"
                :visible="showModal"
                @onPrimaryClick="update">
            <admin-society-form :user="user" :text="text" @localTextUpdated="handleLocalTextUpdated">
            </admin-society-form>
        </inter-modal>
    </b-container>
</template>

<script>

    import {mapActions} from 'vuex'
    import InterModal from "../../../components/modal/InterModal";
    import AdminSocietyForm from "../forms/AdminSocietyForm";
    import AdminSocietyTable from "../components/AdminSocietyTable";
    import HeaderButtons from "../../../components/headers-buttons/HeaderButtons";

    export default {
        name: "AdminSocietiesListView",
        components: {HeaderButtons, AdminSocietyTable, AdminSocietyForm, InterModal},
        data() {
            return {
                societiesTablekey: 1,
                showModal : false,
                buttonPrimary: {
                    label: 'Salva',
                    confirm: true
                },
                user: {},
                text: "",
            }
        },
        mounted() {
            this.$root.$on('bv::modal::hide', () => {
                this.showModal = false;
            })
        },
        methods: {
            handleLocalTextUpdated(localText) {
                this.text = localText;
            },
            ...mapActions({
                authImpersonate: 'authImpersonate',
                adminSocietyUpdate: 'adminSocietyUpdate',
                authResetPassword: 'authResetPassword',
            }),
            onUpdate: function (user) {
                this.user = Object.assign({}, user);
                this.showModal = true;
            },
            update: function () {
                let data = this.user;
                data.text = this.text
                //data.text = this.$refs.AdminSocietyForm.text;
                this.adminSocietyUpdate(data)
                    .then(() => {
                        this.$bvToast.toast('Modifica effettuata correttamente', {
                            title: 'Success',
                            variant: 'success'
                        });
                        this.societiesTablekey += 1;
                        this.showModal = false;
                    }).catch(() => {
                    this.$bvToast.toast('Society non aggiornato', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                })
            },
            impersonate: function (user) {
                this.authImpersonate(user)
                    .then(() => {
                        this.$router.push({name: 'society.dash'});
                    })
                    .catch(() => {
                        this.$bvToast.toast('Non sono riuscito ad impersonare ' + user.name, {
                            title: 'Alert',
                            variant: 'warning'
                        });
                    })
            },
            resetPassword: function (user) {
                this.authResetPassword(user)
                    .then(() => {
                        this.$bvToast.toast('Password resettata', {
                            title: 'Success',
                            variant: 'success'
                        });
                    }).catch(() => {
                    this.$bvToast.toast('Password non resettata', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                })
            }
        }
    }
</script>

<style scoped>

</style>
